import styled from 'styled-components';

export const Root = styled.div`
  margin: 32px 16px 16px 16px;
  text-align: center;
  font-size: 75%;
`;
